/* eslint-disable @typescript-eslint/no-require-imports */

export const IllusLoyaltySignedOut = require('./Illus-LoyaltySignedOut.png');
export const IllusSgRewardsKale = require('./Illus-SgRewardsKale.png');
